<template>
  <div class="main-wrapper">
    <header-new :title="gameDetail.title" :return_id="gameDetail.return_id" :apiKey="key"></header-new>
    <section class="nft-wallet-list pt-120 pb-90" :style="{'background-image': 'url('+require('../assets/images/login-bg.png')+')'} ">
      <div class="container">
        <div class="row">
          <h1 class="text-white"> Ödemeyi tamamlayın </h1>
          <div class="col-md-8">
            <b-alert variant="warning" show> <b>Lütfen Dikkat</b>: Ödeme tamamlanmadan ekrandan ayrılmayınız..</b-alert>
            <div class="mobile-payment-method" >
              <b-skeleton v-if="loading" ></b-skeleton>
              <div v-if="id === '11' && !loading">
                <div class="transaction-status-content">
                  <div class="container">
                    <div class="row" >
                      <div class="col-md-12" >
                        <div class="content" >
                          <div class="address-column rounded">
                            <div class="icon-wrapper bg-success">
                              <span>
                                <i class="fas fa-check text-white"></i>
                              </span>
                            </div>
                            <div class="address-info">
                              <h4>Siparişiniz Başarıyla Tamamlandı.</h4>
                              <h4>İlginiz için teşekkürler.</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="id === '13' && !loading">
                <div class="nft-form-area" v-if="!westernForm.send">
                  <form>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="text-white" @click="copy(western_name)">Alıcı İsim <i class="fas fa-copy text-white"></i></label>
                        <div class="input-field"><input  disabled :value="western_name"> </div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Alıcı Ülke</label>
                        <div class="input-field"><input  disabled :value="western_country"></div>
                      </div>
                      <div class="col-md-12">
                        <b-alert variant="primary" show> <b>Lütfen Dikkat</b>: Western Union ile ödeme yaptıktan sonra aşağıda istenilen bilgileri giriniz..</b-alert>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Gönderici İsim Soyisim</label>
                        <div class="input-field"><input type="tel"  v-model="westernForm.name"> </div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Gönderici Telefon</label>
                        <div class="input-field"><input type="text" v-model="westernForm.phone" ></div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white"> Gönderici Ülke </label>
                        <div class="input-field"><input type="text" v-model="westernForm.country" ></div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white"> MTCN Numaranız </label>
                        <div class="input-field"><input type="text" v-model="westernForm.mtcn" ></div>
                      </div>
                      <div class="col-md-12">
                        <div class="d-flex justify-content-center">
                          <div class="submit-btn" v-if="westernForm.loading"><button > <i class="fas fa spinner fa-spin"></i></button></div>
                          <div class="submit-btn" v-else @click="sendWesternUnion"><button type="submit">Gönder</button></div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="" v-else>
                  <div class="hwit-content">
                    <div class="row g-4">
                      <div class="col-lg-12">
                        <div class="hwit-column">
                          <div class="icon-wrapper">
                            <span>
<svg width="30" height="30" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2133 0C18.6023 0.211025 18.7254 0.536707 18.7134 0.974233C18.6881 1.89641 18.7078 2.82 18.705 3.74288C18.7036 4.24794 18.4264 4.56869 18.0023 4.56869C17.5774 4.56869 17.3017 4.24794 17.3002 3.74218C17.2974 2.8193 17.3171 1.89571 17.2918 0.973529C17.2798 0.536004 17.4022 0.210322 17.7919 0C17.9319 0 18.0726 0 18.2133 0Z" fill="white"></path><path d="M2.98988 16.5953C3.49282 16.5953 3.99576 16.591 4.49871 16.5967C4.96929 16.6016 5.28442 16.8991 5.27387 17.3156C5.26332 17.7172 4.95523 17.9979 4.49941 18.0007C3.49352 18.0056 2.48764 18.0056 1.48175 18.0007C1.01117 17.9986 0.696738 17.6982 0.707289 17.2811C0.717137 16.878 1.02383 16.6016 1.48105 16.5967C1.98399 16.591 2.48693 16.5953 2.98988 16.5953Z" fill="white"></path><path d="M32.9939 18.0021C32.5029 18.0021 32.0112 18.0056 31.5203 18.0007C31.0426 17.9958 30.7303 17.7116 30.7324 17.2945C30.7345 16.8794 31.049 16.5981 31.528 16.5967C32.5219 16.5931 33.5166 16.5924 34.5105 16.5967C34.9853 16.5988 35.3011 16.8879 35.299 17.3022C35.2969 17.7158 34.9811 17.9972 34.5035 18.0014C33.9998 18.0049 33.4969 18.0021 32.9939 18.0021Z" fill="white"></path><path d="M21.8938 18.9775C23.0185 18.9775 24.1433 18.9761 25.268 18.9782C25.7794 18.9789 26.0939 19.2554 26.0861 19.6866C26.0791 20.0974 25.7611 20.3815 25.28 20.3822C23.0305 20.3858 20.781 20.3858 18.5314 20.3822C18.0292 20.3815 17.7112 20.0931 17.7169 19.6633C17.7225 19.2406 18.0236 18.9789 18.5195 18.9775C19.6442 18.9754 20.769 18.9775 21.8938 18.9775Z" fill="white"></path><path d="M22.5366 16.1648C23.4503 16.1648 24.3634 16.1627 25.2771 16.1655C25.7702 16.1669 26.0776 16.4293 26.0867 16.8471C26.0959 17.2713 25.7702 17.5688 25.2729 17.5695C23.4574 17.5731 21.6425 17.5731 19.827 17.5695C19.3311 17.5688 19.0033 17.2664 19.016 16.8429C19.0279 16.4321 19.3438 16.1662 19.8319 16.1648C20.733 16.1634 21.6348 16.1648 22.5366 16.1648Z" fill="white"></path><path d="M0.000703417 29.8778C0.158972 29.664 0.353819 29.4909 0.562734 29.3249C2.61671 27.6937 4.66366 26.0533 6.72256 24.4284C6.89841 24.2899 6.89138 24.1443 6.89138 23.9726C6.89138 18.8525 6.89068 13.7316 6.89279 8.6114C6.89349 7.49789 7.52375 6.6151 8.53527 6.29153C8.78217 6.21275 9.0354 6.17969 9.29566 6.17969C15.0953 6.18109 20.8957 6.17898 26.6954 6.1825C28.098 6.1832 29.1088 7.19472 29.1102 8.59944C29.1144 12.9466 29.1116 17.2937 29.1116 21.6408C29.1116 21.7695 29.1116 21.8982 29.1116 22.1008C29.2664 21.97 29.3853 21.8715 29.5013 21.7709C30.0331 21.3116 30.5628 20.8488 31.0967 20.3915C32.8538 18.8869 35.3228 19.641 35.927 21.8659C35.9411 21.9186 35.9235 21.9862 36.0023 22.0024C36.0023 22.3541 36.0023 22.7058 36.0023 23.0568C35.7104 24.1921 34.8417 24.8737 34.0222 25.601C32.5239 26.9305 31.0334 28.2698 29.5471 29.6126C26.924 31.9831 23.8522 33.1832 20.314 33.1825C17.373 33.1811 14.432 33.1853 11.4903 33.1768C11.2498 33.1761 11.0823 33.2409 10.91 33.4125C10.0427 34.2763 9.21829 35.1844 8.29751 35.9947C8.13362 35.9947 7.96972 35.9947 7.80512 35.9947C7.21003 35.4904 7.19877 35.1626 7.76151 34.5956C8.562 33.7888 9.37233 32.9918 10.1609 32.1731C10.4331 31.8903 10.7229 31.7672 11.1189 31.7686C14.2118 31.7806 17.3055 31.7792 20.3984 31.7742C23.1994 31.7693 25.7465 30.9519 27.8926 29.1505C30.0268 27.3589 32.066 25.4533 34.1411 23.5921C34.4309 23.3325 34.5807 22.985 34.5906 22.5939C34.6074 21.9475 34.3268 21.453 33.7479 21.1709C33.1401 20.8748 32.5626 20.9803 32.0526 21.4206C30.1203 23.0905 28.1888 24.7598 26.2607 26.4346C25.4841 27.1092 24.6217 27.6318 23.651 27.9779C22.5495 28.3704 21.4099 28.4147 20.257 28.4042C18.5231 28.3887 16.7892 28.402 15.0552 28.3985C14.5572 28.3978 14.2498 28.0996 14.2702 27.6578C14.2892 27.252 14.5882 26.9959 15.063 26.9945C16.5746 26.9917 18.0856 26.991 19.5972 26.9952C19.8835 26.9959 20.1564 26.9537 20.4118 26.8229C21.0392 26.5014 21.3726 25.7966 21.2235 25.1101C21.0716 24.4102 20.4462 23.9037 19.6943 23.9023C17.2569 23.8967 14.8203 23.9002 12.383 23.9002C10.5365 23.9002 8.89401 24.4819 7.4513 25.6327C5.42827 27.2463 3.40524 28.86 1.38151 30.4729C0.769539 30.9611 0.498723 30.94 0 30.3695C0.000703417 30.2063 0.000703417 30.0417 0.000703417 29.8778ZM22.3173 26.8602C22.4235 26.8482 22.4925 26.8482 22.5579 26.832C23.4681 26.6104 24.3045 26.2285 25.0248 25.6264C25.8696 24.9208 26.6933 24.19 27.5339 23.4788C27.6767 23.3578 27.7076 23.2277 27.7076 23.054C27.7041 18.2616 27.7055 13.4699 27.7041 8.67752C27.7041 7.94597 27.339 7.58863 26.5969 7.58793C25.1676 7.58652 23.7382 7.59637 22.3089 7.57949C22.0324 7.57597 21.9895 7.66038 21.9909 7.9108C22.0029 9.39852 21.9938 10.887 21.9994 12.3747C22.0008 12.7383 21.9333 13.0549 21.5654 13.2181C21.1743 13.3911 20.8957 13.197 20.6369 12.9269C20.3611 12.6392 20.0678 12.3691 19.7963 12.0778C19.6809 11.954 19.6155 11.9512 19.498 12.075C19.192 12.3986 18.8762 12.7123 18.5547 13.0204C18.1805 13.3792 17.8204 13.3778 17.4455 13.0176C17.1416 12.725 16.8356 12.4331 16.5542 12.1193C16.3917 11.9379 16.2989 11.9737 16.1547 12.1313C15.9015 12.407 15.6229 12.6596 15.3626 12.9297C15.1136 13.1885 14.8477 13.3827 14.4658 13.23C14.0747 13.0739 14.0015 12.7496 14.0029 12.3712C14.0086 10.8715 14.0008 9.37179 14.0107 7.87211C14.0121 7.64702 13.96 7.57949 13.7258 7.5816C12.3084 7.59356 10.8903 7.58722 9.47292 7.58722C8.63726 7.58722 8.29822 7.92276 8.29822 8.75068C8.29822 13.5191 8.29822 18.2883 8.29822 23.0568C8.29822 23.1679 8.29822 23.2784 8.29822 23.4296C8.43609 23.3656 8.52753 23.3199 8.62179 23.2784C9.67199 22.8183 10.7693 22.5208 11.9138 22.5088C14.5382 22.4814 17.1627 22.4863 19.7871 22.5011C21.1194 22.5088 22.2688 23.4619 22.5762 24.7541C22.7478 25.4751 22.6493 26.1659 22.3173 26.8602ZM15.4119 10.792C15.4485 10.8131 15.485 10.8342 15.5216 10.856C15.5912 10.7617 15.6503 10.6569 15.7319 10.5746C16.1892 10.1153 16.5289 10.1167 16.9918 10.5739C17.2752 10.8539 17.5629 11.1303 17.8344 11.4216C17.9604 11.5566 18.0377 11.5629 18.1679 11.4251C18.4816 11.0931 18.8045 10.7688 19.1372 10.4558C19.4502 10.161 19.8223 10.166 20.1445 10.4487C20.2802 10.5676 20.4083 10.6956 20.5911 10.868C20.5911 9.77767 20.5883 8.76334 20.594 7.74901C20.5947 7.59004 20.5067 7.58793 20.3928 7.58793C18.7995 7.58934 17.2056 7.59004 15.6123 7.58652C15.4639 7.58582 15.4091 7.62662 15.4098 7.78348C15.4154 8.78585 15.4119 9.78892 15.4119 10.792Z" fill="white"></path><path d="M6.97508 5.47425C6.96312 5.8541 6.83862 6.06653 6.58328 6.18963C6.30121 6.32539 6.02899 6.29092 5.80248 6.07989C5.48595 5.78446 5.18488 5.47285 4.87819 5.16616C4.29014 4.5788 3.70067 3.99215 3.11543 3.40199C2.75106 3.0341 2.71237 2.62682 3.00429 2.31943C3.30606 2.00218 3.73514 2.03173 4.11217 2.40595C4.96683 3.25567 5.81796 4.11033 6.67191 4.96287C6.84143 5.13169 6.98563 5.31247 6.97508 5.47425Z" fill="white"></path><path d="M29.8372 6.26755C29.439 6.2577 29.2195 6.12898 29.0965 5.85535C28.9741 5.58313 29.0092 5.32357 29.2062 5.1048C29.4172 4.86986 29.6472 4.6518 29.8709 4.42812C30.5575 3.74017 31.2412 3.04942 31.934 2.36781C32.3273 1.98093 32.8555 2.02172 33.0968 2.45081C33.2656 2.75047 33.2319 3.04942 32.9934 3.29139C32.0719 4.22483 31.1427 5.14982 30.2128 6.07411C30.0841 6.20073 29.923 6.27318 29.8372 6.26755Z" fill="white"></path><path d="M12.1461 27C12.5322 26.9958 12.8656 27.3285 12.8593 27.7119C12.853 28.084 12.535 28.3998 12.1615 28.404C11.7817 28.409 11.4687 28.1079 11.4574 27.7274C11.4447 27.3292 11.7528 27.0043 12.1461 27Z" fill="white"></path><path d="M16.3057 19.676C16.3036 20.0586 15.9603 20.392 15.5804 20.3794C15.2069 20.3674 14.9016 20.0481 14.9023 19.671C14.903 19.2729 15.2196 18.9676 15.6205 18.9768C15.9983 18.9852 16.3078 19.301 16.3057 19.676Z" fill="white"></path></svg>                              </span>
                          </div>
                          <div
                              class="hwit-column-right"><span class="count-number">01</span>
                            <div class="column-title">
                              <h4>Bildiriminiz için teşekkürler</h4>
                            </div>
                            <div class="column-desc">
                              <p> Ödeme talebiniz şuanda ekibimiz tarafından kontrol ediliyor. En kısa sürede işleminiz sonuçlandırılacaktır. </p>
                              <p> Geçmiş ödemelerim kısmından ödemenizin sonucunu kontrol edebilirsiniz.</p>
                              <p> İlginiz için teşekkürler ! </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="(id === '14' || id === 14 || id === 15 || id === '15' ) && !loading">
                <div class="nft-form-area" v-if="!swiftFormUsd.send">
                  <form>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="text-white" @click="copy(swift_name)">Alıcı İsim <i class="fas fa-copy text-white"></i></label>
                        <div class="input-field"><input  disabled :value="swift_name"> </div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Alıcı Banka</label>
                        <div class="input-field"><input  disabled :value="swift_bank_name"></div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white" @click="copy(swift_iban)">IBAN <i class="fas fa-copy text-white"></i></label>
                        <div class="input-field"><input  disabled :value="swift_iban"> </div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white" @click="copy('kaptan@kasagame.com')">Alıcı Eposta <i class="fas fa-copy text-white"></i></label>
                        <div class="input-field"><input  disabled :value="'kaptan@kasagame.com'"> </div>
                      </div>
                      <div class="col-md-12">
                        <b-alert variant="primary" show> <b>Lütfen Dikkat</b>: Wise Transfer ile ödeme yaptıktan sonra aşağıda istenilen bilgileri giriniz..</b-alert>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Gönderici İsim Soyisim</label>
                        <div class="input-field"><input type="tel"  v-model="swiftFormUsd.name"> </div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white">Gönderici Telefon</label>
                        <div class="input-field"><input type="text" v-model="swiftFormUsd.phone" ></div>
                      </div>
                      <div class="col-md-6">
                        <label class="text-white"> Gönderici Ülke </label>
                        <div class="input-field"><input type="text" v-model="swiftFormUsd.country" ></div>
                      </div>
                      <div class="col-md-12">
                        <div class="d-flex justify-content-center">
                          <div class="submit-btn" v-if="swiftFormUsd.loading"><button > <i class="fas fa spinner fa-spin"></i></button></div>
                          <div class="submit-btn" v-else @click="sendSwiftForm"><button type="submit">Gönder</button></div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="" v-else>
                  <div class="hwit-content">
                    <div class="row g-4">
                      <div class="col-lg-12">
                        <div class="hwit-column">
                          <div class="icon-wrapper">
                            <span>
<svg width="30" height="30" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2133 0C18.6023 0.211025 18.7254 0.536707 18.7134 0.974233C18.6881 1.89641 18.7078 2.82 18.705 3.74288C18.7036 4.24794 18.4264 4.56869 18.0023 4.56869C17.5774 4.56869 17.3017 4.24794 17.3002 3.74218C17.2974 2.8193 17.3171 1.89571 17.2918 0.973529C17.2798 0.536004 17.4022 0.210322 17.7919 0C17.9319 0 18.0726 0 18.2133 0Z" fill="white"></path><path d="M2.98988 16.5953C3.49282 16.5953 3.99576 16.591 4.49871 16.5967C4.96929 16.6016 5.28442 16.8991 5.27387 17.3156C5.26332 17.7172 4.95523 17.9979 4.49941 18.0007C3.49352 18.0056 2.48764 18.0056 1.48175 18.0007C1.01117 17.9986 0.696738 17.6982 0.707289 17.2811C0.717137 16.878 1.02383 16.6016 1.48105 16.5967C1.98399 16.591 2.48693 16.5953 2.98988 16.5953Z" fill="white"></path><path d="M32.9939 18.0021C32.5029 18.0021 32.0112 18.0056 31.5203 18.0007C31.0426 17.9958 30.7303 17.7116 30.7324 17.2945C30.7345 16.8794 31.049 16.5981 31.528 16.5967C32.5219 16.5931 33.5166 16.5924 34.5105 16.5967C34.9853 16.5988 35.3011 16.8879 35.299 17.3022C35.2969 17.7158 34.9811 17.9972 34.5035 18.0014C33.9998 18.0049 33.4969 18.0021 32.9939 18.0021Z" fill="white"></path><path d="M21.8938 18.9775C23.0185 18.9775 24.1433 18.9761 25.268 18.9782C25.7794 18.9789 26.0939 19.2554 26.0861 19.6866C26.0791 20.0974 25.7611 20.3815 25.28 20.3822C23.0305 20.3858 20.781 20.3858 18.5314 20.3822C18.0292 20.3815 17.7112 20.0931 17.7169 19.6633C17.7225 19.2406 18.0236 18.9789 18.5195 18.9775C19.6442 18.9754 20.769 18.9775 21.8938 18.9775Z" fill="white"></path><path d="M22.5366 16.1648C23.4503 16.1648 24.3634 16.1627 25.2771 16.1655C25.7702 16.1669 26.0776 16.4293 26.0867 16.8471C26.0959 17.2713 25.7702 17.5688 25.2729 17.5695C23.4574 17.5731 21.6425 17.5731 19.827 17.5695C19.3311 17.5688 19.0033 17.2664 19.016 16.8429C19.0279 16.4321 19.3438 16.1662 19.8319 16.1648C20.733 16.1634 21.6348 16.1648 22.5366 16.1648Z" fill="white"></path><path d="M0.000703417 29.8778C0.158972 29.664 0.353819 29.4909 0.562734 29.3249C2.61671 27.6937 4.66366 26.0533 6.72256 24.4284C6.89841 24.2899 6.89138 24.1443 6.89138 23.9726C6.89138 18.8525 6.89068 13.7316 6.89279 8.6114C6.89349 7.49789 7.52375 6.6151 8.53527 6.29153C8.78217 6.21275 9.0354 6.17969 9.29566 6.17969C15.0953 6.18109 20.8957 6.17898 26.6954 6.1825C28.098 6.1832 29.1088 7.19472 29.1102 8.59944C29.1144 12.9466 29.1116 17.2937 29.1116 21.6408C29.1116 21.7695 29.1116 21.8982 29.1116 22.1008C29.2664 21.97 29.3853 21.8715 29.5013 21.7709C30.0331 21.3116 30.5628 20.8488 31.0967 20.3915C32.8538 18.8869 35.3228 19.641 35.927 21.8659C35.9411 21.9186 35.9235 21.9862 36.0023 22.0024C36.0023 22.3541 36.0023 22.7058 36.0023 23.0568C35.7104 24.1921 34.8417 24.8737 34.0222 25.601C32.5239 26.9305 31.0334 28.2698 29.5471 29.6126C26.924 31.9831 23.8522 33.1832 20.314 33.1825C17.373 33.1811 14.432 33.1853 11.4903 33.1768C11.2498 33.1761 11.0823 33.2409 10.91 33.4125C10.0427 34.2763 9.21829 35.1844 8.29751 35.9947C8.13362 35.9947 7.96972 35.9947 7.80512 35.9947C7.21003 35.4904 7.19877 35.1626 7.76151 34.5956C8.562 33.7888 9.37233 32.9918 10.1609 32.1731C10.4331 31.8903 10.7229 31.7672 11.1189 31.7686C14.2118 31.7806 17.3055 31.7792 20.3984 31.7742C23.1994 31.7693 25.7465 30.9519 27.8926 29.1505C30.0268 27.3589 32.066 25.4533 34.1411 23.5921C34.4309 23.3325 34.5807 22.985 34.5906 22.5939C34.6074 21.9475 34.3268 21.453 33.7479 21.1709C33.1401 20.8748 32.5626 20.9803 32.0526 21.4206C30.1203 23.0905 28.1888 24.7598 26.2607 26.4346C25.4841 27.1092 24.6217 27.6318 23.651 27.9779C22.5495 28.3704 21.4099 28.4147 20.257 28.4042C18.5231 28.3887 16.7892 28.402 15.0552 28.3985C14.5572 28.3978 14.2498 28.0996 14.2702 27.6578C14.2892 27.252 14.5882 26.9959 15.063 26.9945C16.5746 26.9917 18.0856 26.991 19.5972 26.9952C19.8835 26.9959 20.1564 26.9537 20.4118 26.8229C21.0392 26.5014 21.3726 25.7966 21.2235 25.1101C21.0716 24.4102 20.4462 23.9037 19.6943 23.9023C17.2569 23.8967 14.8203 23.9002 12.383 23.9002C10.5365 23.9002 8.89401 24.4819 7.4513 25.6327C5.42827 27.2463 3.40524 28.86 1.38151 30.4729C0.769539 30.9611 0.498723 30.94 0 30.3695C0.000703417 30.2063 0.000703417 30.0417 0.000703417 29.8778ZM22.3173 26.8602C22.4235 26.8482 22.4925 26.8482 22.5579 26.832C23.4681 26.6104 24.3045 26.2285 25.0248 25.6264C25.8696 24.9208 26.6933 24.19 27.5339 23.4788C27.6767 23.3578 27.7076 23.2277 27.7076 23.054C27.7041 18.2616 27.7055 13.4699 27.7041 8.67752C27.7041 7.94597 27.339 7.58863 26.5969 7.58793C25.1676 7.58652 23.7382 7.59637 22.3089 7.57949C22.0324 7.57597 21.9895 7.66038 21.9909 7.9108C22.0029 9.39852 21.9938 10.887 21.9994 12.3747C22.0008 12.7383 21.9333 13.0549 21.5654 13.2181C21.1743 13.3911 20.8957 13.197 20.6369 12.9269C20.3611 12.6392 20.0678 12.3691 19.7963 12.0778C19.6809 11.954 19.6155 11.9512 19.498 12.075C19.192 12.3986 18.8762 12.7123 18.5547 13.0204C18.1805 13.3792 17.8204 13.3778 17.4455 13.0176C17.1416 12.725 16.8356 12.4331 16.5542 12.1193C16.3917 11.9379 16.2989 11.9737 16.1547 12.1313C15.9015 12.407 15.6229 12.6596 15.3626 12.9297C15.1136 13.1885 14.8477 13.3827 14.4658 13.23C14.0747 13.0739 14.0015 12.7496 14.0029 12.3712C14.0086 10.8715 14.0008 9.37179 14.0107 7.87211C14.0121 7.64702 13.96 7.57949 13.7258 7.5816C12.3084 7.59356 10.8903 7.58722 9.47292 7.58722C8.63726 7.58722 8.29822 7.92276 8.29822 8.75068C8.29822 13.5191 8.29822 18.2883 8.29822 23.0568C8.29822 23.1679 8.29822 23.2784 8.29822 23.4296C8.43609 23.3656 8.52753 23.3199 8.62179 23.2784C9.67199 22.8183 10.7693 22.5208 11.9138 22.5088C14.5382 22.4814 17.1627 22.4863 19.7871 22.5011C21.1194 22.5088 22.2688 23.4619 22.5762 24.7541C22.7478 25.4751 22.6493 26.1659 22.3173 26.8602ZM15.4119 10.792C15.4485 10.8131 15.485 10.8342 15.5216 10.856C15.5912 10.7617 15.6503 10.6569 15.7319 10.5746C16.1892 10.1153 16.5289 10.1167 16.9918 10.5739C17.2752 10.8539 17.5629 11.1303 17.8344 11.4216C17.9604 11.5566 18.0377 11.5629 18.1679 11.4251C18.4816 11.0931 18.8045 10.7688 19.1372 10.4558C19.4502 10.161 19.8223 10.166 20.1445 10.4487C20.2802 10.5676 20.4083 10.6956 20.5911 10.868C20.5911 9.77767 20.5883 8.76334 20.594 7.74901C20.5947 7.59004 20.5067 7.58793 20.3928 7.58793C18.7995 7.58934 17.2056 7.59004 15.6123 7.58652C15.4639 7.58582 15.4091 7.62662 15.4098 7.78348C15.4154 8.78585 15.4119 9.78892 15.4119 10.792Z" fill="white"></path><path d="M6.97508 5.47425C6.96312 5.8541 6.83862 6.06653 6.58328 6.18963C6.30121 6.32539 6.02899 6.29092 5.80248 6.07989C5.48595 5.78446 5.18488 5.47285 4.87819 5.16616C4.29014 4.5788 3.70067 3.99215 3.11543 3.40199C2.75106 3.0341 2.71237 2.62682 3.00429 2.31943C3.30606 2.00218 3.73514 2.03173 4.11217 2.40595C4.96683 3.25567 5.81796 4.11033 6.67191 4.96287C6.84143 5.13169 6.98563 5.31247 6.97508 5.47425Z" fill="white"></path><path d="M29.8372 6.26755C29.439 6.2577 29.2195 6.12898 29.0965 5.85535C28.9741 5.58313 29.0092 5.32357 29.2062 5.1048C29.4172 4.86986 29.6472 4.6518 29.8709 4.42812C30.5575 3.74017 31.2412 3.04942 31.934 2.36781C32.3273 1.98093 32.8555 2.02172 33.0968 2.45081C33.2656 2.75047 33.2319 3.04942 32.9934 3.29139C32.0719 4.22483 31.1427 5.14982 30.2128 6.07411C30.0841 6.20073 29.923 6.27318 29.8372 6.26755Z" fill="white"></path><path d="M12.1461 27C12.5322 26.9958 12.8656 27.3285 12.8593 27.7119C12.853 28.084 12.535 28.3998 12.1615 28.404C11.7817 28.409 11.4687 28.1079 11.4574 27.7274C11.4447 27.3292 11.7528 27.0043 12.1461 27Z" fill="white"></path><path d="M16.3057 19.676C16.3036 20.0586 15.9603 20.392 15.5804 20.3794C15.2069 20.3674 14.9016 20.0481 14.9023 19.671C14.903 19.2729 15.2196 18.9676 15.6205 18.9768C15.9983 18.9852 16.3078 19.301 16.3057 19.676Z" fill="white"></path></svg>                              </span>
                          </div>
                          <div
                              class="hwit-column-right"><span class="count-number">01</span>
                            <div class="column-title">
                              <h4>Bildiriminiz için teşekkürler</h4>
                            </div>
                            <div class="column-desc">
                              <p> Wise Transfer işlemleri en geç 6 saat içerisinde sonuçlanmaktadır.</p>
                              <p> Ödeme talebiniz şuanda ekibimiz tarafından kontrol ediliyor. En kısa sürede işleminiz sonuçlandırılacaktır. </p>
                              <p> Geçmiş ödemelerim kısmından ödemenizin sonucunu kontrol edebilirsiniz.</p>
                              <p> İlginiz için teşekkürler ! </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <iframe v-else :src="paymentLink" style="width: 1px; min-height: 100vh; min-width: 100%; border: 0px; overflow: auto; height: 906px;"></iframe>
            </div>
          </div>
          <div class="col-xl-4">
            <div class="hero-feature-product">
              <div class="row align-items-center">
                <div class="col-md-12 order-2 order-md-1">
                  <div class="hfp-left">
                    <div class="hfp-title">
                      <h4>SİPARİŞ DETAYI</h4>
                    </div>
                    <div class="hfp-author">
                      <div class="author-info"><span>{{ productDetail.title }}</span>
                        <h6>{{ gameDetail.title }}</h6>
                      </div>
                    </div>
                    <div class="hfp-bidding">
                      <div class="bid-amount"><span>{{ channelDetail.title }}</span>
                        <h4 v-if="id === '13' && loading === false">{{ productDetail.price | currency }} EURO</h4>
                        <h4 v-else-if="id === '14' && loading === false">{{ productDetail.price | currency }} TRY</h4>
                        <h4 v-else-if="id === '15' && loading === false">{{ productDetail.price | currency }} EURO</h4>
                        <h4 v-else>{{ productDetail.price | currency }} TL</h4>
                      </div>
                      <div class="auction-timer">
                        <span>Kalan Süre:</span>
                        <b-badge class="text-danger" v-if="time.seconds < 0"> <i class="fas fa-clock"></i> Süre bitti</b-badge>

                        <ul class="downcount-timer" data-date="05/24/2022 23:59:59" v-if="time.seconds > 0">
                          <li>
                            <h4 class="hours">{{ time.minutes }}</h4><span>dk</span></li>
                          <li>
                            <h4 class="minutes">{{ time.seconds }}</h4><span>s</span></li>
                        </ul>
                      </div>
                    </div>
                    <div class="hfp-btns">
                      <div class="secondary-btn"><router-link :to="{path: '/'+key}">Anasayfa</router-link></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import apiService from "@/services/apiService";
import HeaderNew from "@/components/HeaderNew";
import Footer from "@/components/Footer";
import moment from "moment";
export default {
  name: "Payment",
  data() {
    return {
      key: this.$route.params.key,
      id: this.$route.params.id,
      product_id: this.$route.params.product_id,
      keyErr : false,
      loading: true,
      gameDetail: {
        title: '',
        products: [],
      },
      productDetail: {
        title: ''
      },
      channelDetail: {
        title: ''
      },
      paymentLink: null,
      time: {
        days: 0,
        hours: 0,
        minutes: 25,
        seconds: 0,
      },
      westernForm: {
        name: '',
        phone: '',
        country: '',
        mtcn: '',
        loading: true,
        id: '',
        send: false,
      },
      swiftFormUsd: {
        name: '',
        phone: '',
        country: '',
        loading: true,
        id: '',
        send: false,
        currency: 'usd'
      },
      western_name: '',
      western_country: '',
      swift_name: '',
      swift_bank_name: '',
      swift_iban: '',
      swift_code: '',
      swift_bank_id: '',

    }
  },
  components: { HeaderNew, Footer },
  methods: {
    timer(){
      let eventTime = moment(Date.now()).add(25, 'minutes');
      if(this.id === '13'){
         eventTime = moment(Date.now()).add(120, 'minutes');
         this.time.minutes = 120
      }else{
        this.time.minutes = 25
      }
      const changeTime = (val) => {
        this.changeTime(val)
      }
      setInterval(function() {
        let currentTime = moment(Date.now()).subtract(1, 'seconds');
        let distance = eventTime - currentTime;
        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        let duration_ = {
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        }
        changeTime(duration_)
      }, 1000);

    },
    changeTime(val){
      this.time = val
    },
    successMessage(val) {
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: val,
        text: '',
      });
    },
    errorMessage(val) {
      this.$swal({
        showConfirmButton: true,
        icon: 'error',
        title: 'HATA',
        text: val,
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });
    },
    checkKey() {
      apiService.checkPaymentLink({key: this.key})
          .then((res) => {
            if(res.state) {
              this.keyErr = false
            }
            else {
              this.errorMessage(res.message)
              this.keyErr = true
            }
          })
    },
    gameDetails() {
      apiService.gameDetail({key: this.key})
          .then((res) => {
            if(res.state){
              this.gameDetail = res.data
            }else{
              this.errorMessage(res.message)
              this.keyErr = true
            }
          })
    },
    getProductDetail() {
      apiService.checkProductId({id: this.product_id, key: this.key})
          .then((res) => {
            if(res.state){
              this.productDetail = res.data[0]
            }else{
              this.$router.push({path: '/'+this.key})
            }
          })
    },
    getPaymentChannelDetail() {
      apiService.paymentChannelDetail({id: this.id, key: this.key})
          .then((res) => {
            if(res.state){
              this.channelDetail = res.data[0]
              this.getPayment()
            }else{
              this.$router.push({path: '/'+this.key})
            }
          })
    },
    getPayment(){

      apiService.getPaymentLink({ key: this.key, product_id: this.product_id, method_id: this.id, token: this.$store.getters.user.token})
      .then((res) => {
        if(res.state){
          this.loading = false
          this.paymentLink = res.paymentLink
          this.productDetail.price = res.amount
          if(this.isIOS()){
            window.location.href = this.paymentLink
          }

          if(this.id === '13')
            this.westernForm.id = res.id, this.westernForm.loading = false
          if(this.id === '14' || this.id === '15')
            this.swiftFormUsd.id = res.id
          if(this.id === '2')
            this.gpayInfoMessage()
        }else{
          this.errorMessage(res.message)
          setTimeout(() => {
            this.$router.push({path: '/'+this.key})
          }, 1500)
        }
      })
    },
    isIOS(){
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    gpayInfoMessage(){
      this.$swal({
        allowOutsideClick: true,
        showConfirmButton: true,
        confirmButtonText: 'Anladım',
        icon: 'info',
        title: 'Gpay Banka Havalesi Seçtiniz',
        width: '64em',
        html: '<div class="row">' +
            '<div class="col-md-12"> <img src="https://cdn.kasagame.com/adim-1.png" alt="" style="max-width: 100%"> </div>' +
            '<div class="col-md-12" style="top: 30px; position: relative;"> <img src="https://cdn.kasagame.com/adim-2.png"  style="max-width: 100%"></div>' +
            '</div>'
      });
    },
    sendWesternUnion(){
      this.westernForm.loading = true
      apiService.westernUnion({amount: this.productDetail.price, id: this.westernForm.id, name: this.westernForm.name, phone: this.westernForm.phone, country: this.westernForm.country, mtcn: this.westernForm.mtcn})
          .then((res) => {
            this.westernForm.loading = false
            if(res.state){
              this.westernForm.send = true
            }else{
              this.errorMessage(res.message)
            }
          })
    },
    sendSwiftForm(){
      this.swiftFormUsd.loading = true
      apiService.sendSwiftForm({amount: this.productDetail.price, id: this.swiftFormUsd.id, name: this.swiftFormUsd.name, phone: this.swiftFormUsd.phone, country: this.swiftFormUsd.country, currency: this.swiftFormUsd.currency, bank_id: this.swift_bank_id})
          .then((res) => {
            this.swiftFormUsd.loading = false
            if(res.state){
              this.swiftFormUsd.send = true
            }else{
              this.errorMessage(res.message)
            }
          })
    },
    copy(value){
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Kopyalandı',
        text: value,
      });

      let input = document.createElement('textarea');
      input.innerHTML = value;
      document.body.appendChild(input);
      input.select();
      let result = document.execCommand('copy');
      document.body.removeChild(input);
      return result
    },
    westernInformation(){
      apiService.westernInformation()
      .then((res) => {
        if(res.state){
          this.western_name = res.data.western_name
          this.western_country = res.data.western_country
        }
      })
    },
    swiftInformation(currency){
      this.swiftFormUsd.loading = true
      this.swiftFormUsd.currency = currency
      apiService.swiftBankDetail({currency: currency})
      .then((res) => {
        if(res.state){
          this.swiftFormUsd.loading = false
          this.swift_code = res.data[0].swift_code
          this.swift_name = res.data[0].account_name
          this.swift_bank_name = res.data[0].bank_name
          this.swift_iban = res.data[0].iban
          this.swift_bank_id = res.data[0].id
        }
      })
    }
  },
  created() {
    this.key = this.$route.params.key
    this.checkKey()
    this.gameDetails()
    this.getProductDetail()
    this.getPaymentChannelDetail()
    this.timer()
    if(this.id === 13 || this.id === '13')
      this.westernInformation()
    if(this.id === 14 || this.id === '14')
      this.swiftInformation('usd')
    if(this.id === 15 || this.id === '15')
      this.swiftInformation('euro')
  },
  watch: {
    keyErr : function () {
      if(this.keyErr)
        setTimeout(() => {
          window.location.href = 'https://kasagame.com'
        }, 1500)
    }
  }
}
</script>

<style >
/deep/.swal2-popup {
  width: 64rem !important;
}
</style>